import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, PlusCircle, Printer, Star, Layout, PenTool, Type, FileText, SmilePlus, Puzzle, MessageCircleHeart, Map, Dice1, Trophy, Users, Award } from 'lucide-react';
const modules = [{
  title: 'Trazos y motricidad fina',
  icon: <PenTool size={24} data-id="element-139" />
}, {
  title: 'Letras mayúsculas',
  icon: <Type size={24} data-id="element-140" />
}, {
  title: 'Letras minúsculas',
  icon: <Type size={24} className="lowercase" data-id="element-141" />
}, {
  title: 'Palabras y vocabulario',
  icon: <FileText size={24} data-id="element-142" />
}, {
  title: 'Escritura práctica y divertida',
  icon: <SmilePlus size={24} data-id="element-143" />
}];
const bonuses = [{
  title: 'Actividades extra',
  icon: <Puzzle size={20} data-id="element-144" />
}, {
  title: 'Juegos educativos',
  icon: <Dice1 size={20} data-id="element-145" />
}, {
  title: 'Frases positivas',
  icon: <MessageCircleHeart size={20} data-id="element-146" />
}, {
  title: 'Laberintos',
  icon: <Map size={20} data-id="element-147" />
}, {
  title: 'Une los puntos',
  icon: <Layout size={20} data-id="element-148" />
}, {
  title: 'Desafíos de escritura',
  icon: <Trophy size={20} data-id="element-149" />
}];
const pluses = [{
  title: 'Guía para mamás',
  icon: <Users size={20} data-id="element-150" />
}, {
  title: 'Guía para docentes',
  icon: <BookOpen size={20} data-id="element-151" />
}, {
  title: 'Sistema de recompensas',
  icon: <Award size={20} data-id="element-152" />
}];
const reasons = ['Fácil de implementar.', 'Actividades listas para usar.', 'Diseñado para niños de 3 a 10 años.', 'Aprendizaje mediante el juego.', 'Ideal para el hogar y la escuela.', 'Material imprimible.'];
export function ProductDetailsSection() {
  return <>
      {/* SECTION 4: WHAT'S INCLUDED */}
      <section id="incluye" className="py-24 bg-brand-blue/10" data-id="element-153">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-155">
            <h2 className="md:text-5xl font-extrabold text-brand-dark mb-6 text-[32px]" data-id="element-156">
              Todo lo que recibís hoy
            </h2>
            <div className="w-24 h-2 bg-brand-yellow mx-auto rounded-full" data-id="element-157"></div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-158">
            {/* Modules */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-3xl p-8 shadow-soft border-t-8 border-brand-blue" data-id="element-159">
              <div className="flex items-center gap-3 mb-6" data-id="element-160">
                <BookOpen className="text-brand-blue" size={32} data-id="element-161" />
                <h3 className="text-2xl font-bold text-brand-dark" data-id="element-162">
                  5 MÓDULOS
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-163">
                {modules.map((mod, i) => <li key={i} className="flex items-center gap-3 bg-slate-50 p-3 rounded-xl border border-slate-100" data-id="element-164">
                    <div className="text-brand-primary" data-id="element-165">{mod.icon}</div>
                    <span className="font-bold text-brand-dark" data-id="element-166">
                      {mod.title}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Bonuses */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-3xl p-8 shadow-soft border-t-8 border-brand-mint" data-id="element-167">
              <div className="flex items-center gap-3 mb-6" data-id="element-168">
                <Gift className="text-emerald-500" size={32} data-id="element-169" />
                <h3 className="text-2xl font-bold text-brand-dark" data-id="element-170">6 BONUS</h3>
              </div>
              <ul className="space-y-4" data-id="element-171">
                {bonuses.map((bonus, i) => <li key={i} className="flex items-center gap-3" data-id="element-172">
                    <div className="bg-brand-mint/30 p-2 rounded-lg text-emerald-600" data-id="element-173">
                      {bonus.icon}
                    </div>
                    <span className="font-semibold text-slate-700" data-id="element-174">
                      {bonus.title}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Plus & Special Bonus */}
            <div className="space-y-8" data-id="element-175">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="bg-white rounded-3xl p-8 shadow-soft border-t-8 border-brand-lilac" data-id="element-176">
                <div className="flex items-center gap-3 mb-6" data-id="element-177">
                  <PlusCircle className="text-purple-500" size={32} data-id="element-178" />
                  <h3 className="text-2xl font-bold text-brand-dark" data-id="element-179">3 PLUS</h3>
                </div>
                <ul className="space-y-4" data-id="element-180">
                  {pluses.map((plus, i) => <li key={i} className="flex items-center gap-3" data-id="element-181">
                      <div className="bg-brand-lilac/30 p-2 rounded-lg text-purple-600" data-id="element-182">
                        {plus.icon}
                      </div>
                      <span className="font-semibold text-slate-700" data-id="element-183">
                        {plus.title}
                      </span>
                    </li>)}
                </ul>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="bg-gradient-to-br from-brand-yellow to-amber-200 rounded-3xl p-8 shadow-lg relative overflow-hidden" data-id="element-184">
                <div className="absolute -right-4 -top-4 text-white/40" data-id="element-185">
                  <Printer size={100} data-id="element-186" />
                </div>
                <div className="relative z-10" data-id="element-187">
                  <div className="inline-block bg-brand-dark text-white text-xs font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-188">
                    Bonus Especial
                  </div>
                  <h3 className="text-xl font-bold text-brand-dark mb-2 flex items-center gap-2" data-id="element-189">
                    🎁 Plantillas imprimibles
                  </h3>
                  <p className="text-brand-dark/80 font-medium" data-id="element-190">
                    Hojas de caligrafía listas para imprimir y usar cuantas
                    veces quieras.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: WHY CHOOSE THIS METHOD */}
      <section className="py-20 bg-white overflow-hidden" data-id="element-191">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-193">
            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-dark mb-6" data-id="element-194">
              ¿Por qué tantas familias lo están eligiendo?
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-195">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-slate-50 hover:bg-brand-mint/10 transition-colors rounded-2xl p-6 text-center border border-slate-100 shadow-sm flex flex-col items-center justify-center gap-4 group" data-id="element-196">
                <div className="bg-white p-3 rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-197">
                  <Star className="text-brand-yellow" size={32} fill="currentColor" data-id="element-198" />
                </div>
                <p className="font-bold text-brand-dark text-lg" data-id="element-199">{reason}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </>;
}